import {Route} from "react-router-dom";
import React from "react";
import PublicationSelectorContainer from "../components/PublicationSelectorContainer";
//import DandOCreationForm from "../components/DandOCreationForm";

export const PUBLICATION_SELECTION_ROUTE =  <Route path="/publications" exact component={PublicationSelectorContainer}/>;
//export const DANDO_CREATION_ROUTE =  <Route path="/dandos/create" exact component={DandOCreationForm}/>;
//export const DANDO_UPDATION_ROUTE =  <Route path="/dandos/update/:dandoId" exact component={DandOCreationForm}/>;



// WEBPACK FOOTER //
// ./src/publications/routes/routes.js